export default "__VITE_ASSET__DRZrxOEi__";